/*
 * modal / header
 */
export function initHeaderModal() {
    
    /**
     * ヘッダー内のボタンをクリックしたとき
     */
    function headerModalOpen(e) {
        let modalName = $(e).data('modal');
        let buttonSelector = '.s-headerBtn--' + modalName;
        let $button = $(buttonSelector);
        let $target = $('.s-header_balloon--' + modalName);
        let pageHeight = $(document).height();

        $(document).on('click', buttonSelector, function() {
            let $openedModal = $('.s-header_balloon.is-show');
            if( $openedModal.length == 0 ) {
                $target.addClass('is-show');
                $button.addClass('is-on');
                $button.attr('aria-expanded', true);
                
                /* ▼ ページの高さが低いとき ▼ */
                let headerHeight = $('header').height();
                let footerHeight = $('footer').outerHeight();
                let balloonHeight = $('.p-header_balloon--' + modalName).outerHeight();
                let mainHeight = pageHeight - headerHeight - footerHeight;
                let lossHeight = balloonHeight - pageHeight + 40;

                if( lossHeight > 0 ) {
                    let addHeight = lossHeight + 100;
                    $('.s-main').css({
                        'margin-bottom': addHeight
                    });
                }
                /* ▲ ページの高さが低いとき ▲ */
                

            } else {
                $target.removeClass('is-show');
                $button.removeClass('is-on');
                $button.attr('aria-expanded', false);
                $('.s-main').css({
                    'margin-bottom': '0'
                });
                
            }
        });
    }
    
    $('.s-header_balloon').each(function(i, e) {
        headerModalOpen(e);
    });
    
    /**
     * モーダル以外のエリアをクリックして閉じる
     */
    $(document).on('click', '.s-header_balloon-overlay', function() {
        $('.s-header_balloon').removeClass('is-show');
        $('.s-headerModal').removeClass('is-on');
        $('.s-headerModal').attr('aria-expanded', false);
        $('.s-main').css({
            'margin-bottom': '0'
        });
    });


}